<template>
	<div class="main-cont">
		<h1 class="header-desc">{{ intro }}</h1>
		<div class="block-cont">
			<div class="image-cont">
                <img :src="appimg"/>
            </div>
            <div class="wrapper-back"/>
            <div class="wrapper-cont">
                <div class="description-btns">
                    <button v-on:click="i = 0">{{ desca }}</button>
                    <button v-on:click="i = 1">{{ descb }}</button>
                    <button v-on:click="i = 2">{{ descc }}</button>
                </div>
                <div class="description-cont">
                    <p>{{ conts[i].desc }}</p>
                    <ul>
                        <li v-for="j in conts[i].list" v-bind:data="j" v-bind:key="j">{{ j }}</li>
                    </ul>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Goals',
    data () {
        return {
            intro:	'¿Qué es Electchain?',
	        desca: 'Una iniciativa',
	        descb: 'Un proceso',
	        descc: 'Una aplicación',
	        conts:[
                {
                    desc: 'Garantizar la efectividad de un proceso electoral alterno, mediante el uso de nuevas tecnologias',
                    list:
                    [
                        'Crear una plataforma digital para votaciones segura e inalterable',
                        'Llevar a cabo procesos electorales de una forma más ágil',
						'Demostrar a la población la integridad de los votos emitidos',
                    ]
                },
                {
                    desc:'Permitir la creación de un proceso alterno de votaciones no oficiales. En éste proceso se garantiza:',
                    list:
                    [
                        'Descartar la intervención política interna o externa a excepción del apoyo institucional',
                        'Eliminar el problema del doble voto así como la suplantación del mismo',
                        'Reducir los costos implicados al realizar un proceso electoral',
                        'Mostrar los resultados del proceso electoral alterno en tiempo y forma'
                    ]
                },
                {
					desc: 'Desarrollar una herramienta digital para móviles y navegadores, basada en tecnología Blockchain',
                    list: 
                    [
                        'Acercar a la población al uso de nuevas tecnologías que mantengan al pais a la vanguardia',
                        'Constatar que tus datos personales no serán almacenados por Electchain ni por terceros',
                        'Permitir a la población ejercer el derecho del voto desde un dispositivo conectado a internet'
                    ]
                },
            ],
            appimg:    require('./assets/web.png'),
            i: 0
	    }
    }
}
</script>

<style scoped>
.main-cont{
    background-color: transparent;
}
img{
    max-width:  480px;
}

.wrapper-back{
	position: absolute;
    left: 0;
    width: 100%;
    height: 480px;

	background: url(./assets/elect.jpg) no-repeat center;
    background-size: cover;
    opacity: 0.25;

    transform: skewY(-3deg);
    transform-origin: top left;
}
.wrapper-back::after{
    content: "";
    background: #013e7b;
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;  
}
.wrapper-cont{
    position: relative;
    z-index: 1;
}

.description-btns{
    display: flex;
    justify-content: space-around;
    padding: 20px 0;
    border-bottom: 1px inset white;
}
.description-cont{
    padding-top: 20px;
    font-size: 20px;
}

p{
    font-size: 24px;
}
ul{
    text-align: justify;
    margin: unset;
}
li{
    padding: 5px 10px;
}

button{
  box-shadow: 0px 1px 5px #ffffff;
  background: transparent;
  color: #ffffff;
  font-size: 20px;
  width: 240px;
  padding: 10px 20px 10px 20px;
  border: solid teal 2px;
  text-decoration: none;
  cursor: pointer;
}
button:hover{
	background: #2d598b;
}

@media screen and (min-width: 480px) and (max-width: 820px){
    .main-cont{
        display: unset;
    }
    .block-cont{
        display: unset;
        margin: auto;
    }
    img{
        max-width: 420px;
        max-height: 420px;
    }
    p{
        font-size: 20px;
    }
    .description-cont{
        font-size: 18px;
    }
}
@media screen and (max-width: 480px){
    .block-cont{
        display: unset;
        margin: auto;
    }
    img{
        max-width: 240px;
        max-height: 240px;
    }
    p{
        font-size: 18px;
    }

    .wrapper-back{
        height: 640px;
    }
    .description-btns{
        display: block;
    }
    .description-cont{
        padding-top: 20px;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Description.vue